import React from 'react';

import sportsbetLogo from '../../assets/sb.png';
import tabLogo from '../../assets/tab.jpg';
import pointsbetLogo from '../../assets/pb.png';
import nedsLogo from '../../assets/neds.jpg';
import betrightLogo from '../../assets/betright.jpg';
import bet365Logo from '../../assets/bet365.png';
import betmakersLogo from '../../assets/betmakers.png';
import ladbrokesLogo from '../../assets/ladbrokes.webp';
import fanduelLogo from '../../assets/fanduel.jpg';
import draftkingsLogo from '../../assets/draftkings.jpg';
import betmgmLogo from '../../assets/betmgm.png';
import dabbleLogo from '../../assets/dabble.webp';
import pinnacleLogo from '../../assets/pn_logo.jpeg';
import tabtouchLogo from '../../assets/tabtouch.webp';
import amusedLogo from '../../assets/amused.jpg';

export const BOOKMAKER_LOGOS = {
    sportsbet: sportsbetLogo,
    tab: tabLogo,
    pointsbet: pointsbetLogo,
    neds: nedsLogo,
    betright: betrightLogo,
    bet365: bet365Logo,
    betmakers: betmakersLogo,
    ladbrokes: ladbrokesLogo,
    fanduel: fanduelLogo,
    draftkings: draftkingsLogo,
    betmgm: betmgmLogo,
    dabble: dabbleLogo,
    pinnacle: pinnacleLogo,
    tabtouch: tabtouchLogo,
    amused: amusedLogo,
};

export const BOOKMAKER_DISPLAY_NAMES = {
    sportsbet: 'Sportsbet',
    tab: 'TAB',
    pointsbet: 'Pointsbet',
    neds: 'Neds',
    betright: 'Betright',
    bet365: 'Bet365',
    betmakers: 'Betmakers',
    ladbrokes: 'Ladbrokes',
    fanduel: 'FanDuel',
    draftkings: 'DraftKings',
    betmgm: 'BetMGM',
    dabble: 'Dabble',
    pinnacle: 'Pinnacle',
    tabtouch: 'TabTouch',
    amused: 'Amused',
};

export const KNOWN_BOOKMAKERS = [
    'sportsbet',
    'bet365',
    'tab',
    'tabtouch',
    'pointsbet',
    'betright',
    'betmakers',
    'neds',
    'ladbrokes',
    'dabble',
    'amused',
];

const AFL_ABBREVIATIONS = {
    'adelaide': 'ADEL', 'adelaide crows': 'ADEL', 'crows': 'ADEL',
    'brisbane': 'BRIS', 'brisbane lions': 'BRIS', 'lions': 'BRIS',
    'carlton': 'CARL', 'blues': 'CARL',
    'collingwood': 'COLL', 'magpies': 'COLL',
    'essendon': 'ESS', 'bombers': 'ESS',
    'fremantle': 'FRE', 'dockers': 'FRE',
    'geelong': 'GEEL', 'geelong cats': 'GEEL', 'cats': 'GEEL',
    'gold coast': 'GC', 'gold coast suns': 'GC', 'suns': 'GC',
    'gws': 'GWS', 'gws giants': 'GWS', 'giants': 'GWS', 'greater western sydney': 'GWS',
    'hawthorn': 'HAW', 'hawks': 'HAW',
    'melbourne': 'MELB', 'demons': 'MELB',
    'north melbourne': 'NM', 'kangaroos': 'NM',
    'port adelaide': 'PORT', 'power': 'PORT',
    'richmond': 'RICH', 'tigers': 'RICH',
    'st kilda': 'STK', 'saints': 'STK',
    'sydney': 'SYD', 'sydney swans': 'SYD', 'swans': 'SYD',
    'west coast': 'WCE', 'west coast eagles': 'WCE', 'eagles': 'WCE',
    'western bulldogs': 'WB', 'bulldogs': 'WB',
};

export function shortenMatchName(match, sportKey = 'afl') {
    if (!match) return '';
    const parts = match.split(' vs ');
    if (parts.length !== 2) return match;
    if (sportKey === 'afl') {
        const abbr = (team) => AFL_ABBREVIATIONS[team.trim().toLowerCase()] || team.trim();
        return `${abbr(parts[0])} v ${abbr(parts[1])}`;
    }
    const lastWord = (t) => {
        const w = t.trim().split(' ');
        return w[w.length - 1];
    };
    return `${lastWord(parts[0])} vs ${lastWord(parts[1])}`;
}

export function formatStartTime(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const now = new Date();
    const today = d.toDateString() === now.toDateString();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const isTomorrow = d.toDateString() === tomorrow.toDateString();
    const timeStr = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    if (today) return `Today ${timeStr}`;
    if (isTomorrow) return `Tomorrow ${timeStr}`;
    const dateStr = d.toLocaleDateString([], { month: 'short', day: 'numeric' });
    return `${dateStr} ${timeStr}`;
}

export function formatOdds(odds) {
    if (odds === null || odds === undefined || Number.isNaN(Number(odds))) return '-';
    return Number(odds).toFixed(2);
}

export function formatPct(v, { showSign = true, digits = 1 } = {}) {
    if (v == null || Number.isNaN(Number(v))) return '—';
    const n = Number(v);
    const sign = n > 0 && showSign ? '+' : '';
    return `${sign}${n.toFixed(digits)}%`;
}

/** Stable identity for an AFL value bet. Matches SnipeFeed.getBetKey for MV strategies. */
export function getLegKey(bet) {
    return `${bet.player}|${bet.match}|${bet.market}`;
}

/** AFL prop-type categorisation (must align with Snipe Feed's filter). */
export const AFL_PROP_TYPE_OPTIONS = [
    { value: 'all', label: 'All Props' },
    { value: 'disposals', label: 'Disposals' },
    { value: 'goals', label: 'Goals' },
    { value: 'marks', label: 'Marks' },
    { value: 'tackles', label: 'Tackles' },
    { value: 'fantasy_points', label: 'Fantasy Points' },
    { value: 'kicks', label: 'Kicks' },
    { value: 'handballs', label: 'Handballs' },
    { value: 'clearances', label: 'Clearances' },
    { value: 'hit_outs', label: 'Hit Outs' },
];

/** Dataset / season options for implied-edge calculations. Mirrors Snipe Feed. */
export const AFL_SEASON_OPTIONS = [
    { value: '2026', label: '2026' },
    { value: 'combined', label: '2025 + 2026' },
];

export const AFL_SEASON_SHORT_LABEL = {
    '2026': '2026',
    combined: '2025+26',
};

/**
 * Resolve implied-edge fields for a leg/opportunity given the selected season view.
 *
 *  - '2026'      → reads API-provided 2026 hit-rate fields directly.
 *  - 'combined'  → sums 2025 + 2026 line_hit / total_games and re-derives hit-rate.
 *
 * `bestOdds` is the price we evaluate implied EV against (anchor price for multi legs).
 */
export function getImpliedFields(source, seasonView, bestOdds) {
    if (!source) {
        return {
            lineHit: null,
            totalGames: null,
            hitRatePercentage: null,
            impliedOdds: null,
            impliedEv: null,
        };
    }

    if (seasonView === 'combined') {
        const lineHit2025 = Number.isFinite(source['2025_line_hit']) ? source['2025_line_hit'] : 0;
        const lineHit2026 = Number.isFinite(source['2026_line_hit']) ? source['2026_line_hit'] : 0;
        const total2025 = Number.isFinite(source['2025_total_games']) ? source['2025_total_games'] : 0;
        const total2026 = Number.isFinite(source['2026_total_games']) ? source['2026_total_games'] : 0;

        const lineHit = lineHit2025 + lineHit2026;
        const totalGames = total2025 + total2026;

        if (totalGames <= 0) {
            return { lineHit: 0, totalGames: 0, hitRatePercentage: null, impliedOdds: null, impliedEv: null };
        }

        const hitRate = lineHit / totalGames;
        const hitRatePercentage = hitRate * 100;
        const impliedOdds = hitRate > 0 ? 1 / hitRate : null;
        const impliedEv = Number.isFinite(bestOdds) && bestOdds > 0
            ? hitRatePercentage - (100 / bestOdds)
            : null;
        return { lineHit, totalGames, hitRatePercentage, impliedOdds, impliedEv };
    }

    return {
        lineHit: source['2026_line_hit'] ?? null,
        totalGames: source['2026_total_games'] ?? null,
        hitRatePercentage: source['2026_hit_rate_percentage'] ?? null,
        impliedOdds: source['2026_implied_odds'] ?? null,
        impliedEv: source['2026_implied_ev'] ?? null,
    };
}

export function isImpliedValid({ impliedOdds }) {
    return impliedOdds != null && impliedOdds !== 0 && impliedOdds !== 100;
}

export function getAflPropTypeFromMarket(market) {
    const m = (market || '').toLowerCase();
    if (m.includes('disposal')) return 'disposals';
    if (m.includes('fantasy')) return 'fantasy_points';
    if (m.includes('goal')) return 'goals';
    if (m.includes('handball')) return 'handballs';
    if (m.includes('kick')) return 'kicks';
    if (m.includes('mark')) return 'marks';
    if (m.includes('tackle')) return 'tackles';
    if (m.includes('clearance')) return 'clearances';
    if (m.includes('hit')) return 'hit_outs';
    return null;
}

export function BookmakerLogo({ bookmaker, size = 20 }) {
    const logo = BOOKMAKER_LOGOS[bookmaker];
    const displayName = BOOKMAKER_DISPLAY_NAMES[bookmaker] || bookmaker;
    if (logo) {
        return (
            <img
                src={logo}
                alt={displayName}
                style={{ width: size, height: size }}
                className="rounded object-cover"
                title={displayName}
            />
        );
    }
    return (
        <span
            className="text-[9px] font-mono text-slate-500 uppercase tracking-wider"
            title={displayName}
        >
            {String(displayName).substring(0, 3)}
        </span>
    );
}

/**
 * Compact, tone-aware metric badge — same look used in SnipeFeed for Edge% / Implied EV.
 */
export function MetricBadge({ value, formatted, tone, showArrow = true }) {
    if (value == null || Number.isNaN(value)) {
        return <span className="text-slate-700 font-mono text-[11px]">—</span>;
    }
    const inferredTone = tone || (value < 0 ? 'red' : 'emerald');
    const styles = inferredTone === 'red'
        ? 'bg-red-500/10 border-red-500/30 text-red-400'
        : 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400';
    const positive = value > 0;
    return (
        <div className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border ${styles}`}>
            {showArrow && (
                <svg
                    className="w-2.5 h-2.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    {positive ? (
                        <path d="M12 19V5M5 12l7-7 7 7" />
                    ) : (
                        <path d="M12 5v14M5 12l7 7 7-7" />
                    )}
                </svg>
            )}
            <span className="text-[11px] font-mono font-bold tabular-nums leading-none">
                {formatted}
            </span>
        </div>
    );
}

/**
 * Compute combined multi metrics.
 *
 * Edge convention: **expected-value percentage (EV%)**, i.e. the relative percent
 * return per unit staked. This is the only formulation that preserves correctly
 * under multiplication of probabilities, so it's the right metric for parlays.
 *
 *   ev% = (book_odds × true_prob − 1) × 100
 *
 * (For multis, that's equivalent to `(combinedOdds / fairOdds − 1) × 100`, where
 * `fairOdds = 1 / true_prob_combined`.)
 *
 *  - `combinedOdds`        = product of leg.offeredOdds (the price at the anchor bookmaker).
 *  - `fairCombinedOdds`    = product of leg.avgMarketOdds (consensus reference for the multi).
 *  - `marketEvPct`         = (combinedOdds / fairCombinedOdds − 1) × 100. Positive = book is
 *                            paying more than the bookmaker-consensus multi price.
 *  - `combinedHitRate`     = product of per-leg true hit-rate decimals (null if any leg lacks
 *                            a valid historical hit rate). Assumes leg independence — accurate
 *                            for multi-game parlays, less so for same-game multis.
 *  - `combinedImpliedOdds` = 1 / combinedHitRate (the "fair" multi odds from historical hit rate).
 *  - `historicalEvPct`     = (combinedOdds × combinedHitRate − 1) × 100. Positive = historical
 *                            hit rate suggests the multi pays more than the true probability.
 */
export function computeMultiMetrics(legs) {
    if (!Array.isArray(legs) || legs.length === 0) {
        return {
            combinedOdds: null,
            fairCombinedOdds: null,
            marketEvPct: null,
            combinedHitRate: null,
            combinedImpliedOdds: null,
            historicalEvPct: null,
        };
    }

    let combinedOdds = 1;
    let fairCombinedOdds = 1;
    let combinedHitRate = 1;
    let hasFair = true;
    let hasHitRate = true;

    legs.forEach((leg) => {
        const offered = Number(leg?.offeredOdds);
        const fair = Number(leg?.avgMarketOdds);
        if (!Number.isFinite(offered) || offered <= 0) {
            combinedOdds = NaN;
        } else {
            combinedOdds *= offered;
        }
        if (!Number.isFinite(fair) || fair <= 0) {
            hasFair = false;
        } else {
            fairCombinedOdds *= fair;
        }
        const hitRatePct = Number(leg?.hitRatePercentage);
        if (!Number.isFinite(hitRatePct) || hitRatePct <= 0) {
            hasHitRate = false;
        } else {
            combinedHitRate *= hitRatePct / 100;
        }
    });

    const finalCombined = Number.isFinite(combinedOdds) ? Math.round(combinedOdds * 100) / 100 : null;
    const finalFair = hasFair ? Math.round(fairCombinedOdds * 100) / 100 : null;

    // Market EV% — expected return vs the bookmaker-consensus multi price.
    // Compounds the multi-leg relative edge correctly (pp difference degenerates
    // toward zero as combined probability shrinks; EV% does not).
    const marketEvPct =
        finalCombined != null && finalCombined > 0 && finalFair != null && finalFair > 0
            ? (finalCombined / finalFair - 1) * 100
            : null;

    const finalHitRate = hasHitRate ? combinedHitRate : null;
    const finalImpliedOdds = finalHitRate ? 1 / finalHitRate : null;

    // Historical EV% — expected return assuming the historical hit rate is the
    // true probability. (Same relative-EV form as marketEvPct.)
    const historicalEvPct =
        finalCombined != null && finalCombined > 0 && finalHitRate != null
            ? (finalCombined * finalHitRate - 1) * 100
            : null;

    return {
        combinedOdds: finalCombined,
        fairCombinedOdds: finalFair,
        marketEvPct,
        combinedHitRate: finalHitRate,
        combinedImpliedOdds: finalImpliedOdds,
        historicalEvPct,
    };
}

/**
 * For every available bookmaker, compute its combined-odds price for the current legs.
 * A bookmaker is only included if it has a price for **every** leg.
 *
 * `bookmakerOddsByLeg` is a map of legKey -> { [bookmaker]: number } describing what each
 * book is currently offering for each leg.
 */
export function computeBookmakerComparison(legs, bookmakerOddsByLeg) {
    if (!Array.isArray(legs) || legs.length === 0) return [];

    const bookmakerLegOdds = new Map();
    legs.forEach((leg) => {
        const oddsForLeg = bookmakerOddsByLeg[leg.key] || {};
        Object.entries(oddsForLeg).forEach(([bk, price]) => {
            const v = Number(price);
            if (!Number.isFinite(v) || v <= 0) return;
            if (!bookmakerLegOdds.has(bk)) bookmakerLegOdds.set(bk, []);
            bookmakerLegOdds.get(bk).push(v);
        });
    });

    const results = [];
    for (const [bk, prices] of bookmakerLegOdds.entries()) {
        if (prices.length !== legs.length) continue; // doesn't cover all legs
        const combined = prices.reduce((acc, p) => acc * p, 1);
        results.push({
            bookmaker: bk,
            combinedOdds: Math.round(combined * 100) / 100,
            coverage: prices.length,
        });
    }
    results.sort((a, b) => b.combinedOdds - a.combinedOdds);
    return results;
}
